<kl-form-container
  [title]="
    title + (mode === 'edit' || mode === 'view' ? entity.license_key : '')
  "
  [mode]="mode"
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [alertType]="alertType"
  [saveAndNew]="false"
  (onCloseAlert)="alertShow = false"
  (onCommitSave)="commitSave()"
>
  <form
    #licanceKeyForm="ngForm"
    class="modal-form"
    style="overflow: unset !important"
    novalidate
  >
    <div class="col-md-12 col-sm-12">
      <div class="form-group row">
        <div class="col-md-3 col-sm-12">
          <label for="license_key">
            <small> {{ "license_key" | translate }}</small>
          </label>
        </div>
        <div class="col-md-9 col-sm-12">
          <input
            type="text"
            class="form-control form-control-sm"
            [disabled]="true"
            name="license_key"
            id="license_key"
            [(ngModel)]="entity.license_key"
          />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3 col-sm-12">
          <label for="installed">
            <small>{{ "installed" | translate }}</small>
          </label>
        </div>
        <div class="col-md-9 col-sm-12">
          <p-dropdown
            [disabled]="isReadOnly"
            [options]="[
              { label: 'YES' | translate, value: 'YES' },
              { label: 'NO' | translate, value: 'NO' }
            ]"
            [(ngModel)]="entity.installed"
            name="installed"
            id="installed"
            [style]="{ width: '100%' }"
          >
          </p-dropdown>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3 col-sm-12">
          <label for="locked">
            <small>{{ "locked" | translate }}</small>
          </label>
        </div>
        <div class="col-md-9 col-sm-12">
          <p-dropdown
            [disabled]="isReadOnly"
            [options]="[
              { label: 'YES' | translate, value: 'YES' },
              { label: 'NO' | translate, value: 'NO' }
            ]"
            [(ngModel)]="entity.locked"
            name="locked"
            id="locked"
            [style]="{ width: '100%' }"
          >
          </p-dropdown>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3 col-sm-12">
          <label for="lock_reason">
            <small> {{ "lock_reason" | translate }}</small>
          </label>
        </div>
        <div class="col-md-9 col-sm-12">
          <input
            type="text"
            class="form-control form-control-sm"
            [disabled]="isReadOnly"
            maxlength="200"
            name="lock_reason"
            id="lock_reason"
            [(ngModel)]="entity.lock_reason"
          />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3 col-sm-12">
          <label for="lem_end_date">
            <small> {{ "lem_end_date" | translate }}</small>
          </label>
        </div>
        <div class="col-md-9 col-sm-12">
          <p-calendar
            id="documentDate"
            [style]="{ width: '100%' }"
            [locale]="locale"
            [dateFormat]="dateFormatString"
            styleClass="dateInput"
            [disabled]="isReadOnly"
            [showIcon]="true"
            utc="true"
            #documentDate="ngModel"
            name="documentDate"
            [ngClass]="alertShow && documentDate.invalid ? 'err' : ''"
            [(ngModel)]="lem_end_date"
            required
          >
            <ng-template pTemplate="date" let-date>
              <span>{{ date.day | translate }}</span>
            </ng-template>
          </p-calendar>
        </div>
      </div>
    </div>
  </form>
</kl-form-container>
